import { demkyParser } from "./parser";
import * as ActionTypes from "../../constantes/actionTypes"
import { AnalysisError, AnalysisStep } from "../../type";
import { trackPlausibleEvent } from "../../services/analytics";

const getVisualizationPixels = (visualization: any): { x: number, y: number }[] => {
    if (visualization?.detected_pixels?.length) {
        return visualization.detected_pixels;
    }

    const predictions = [
        ...(visualization?.pred ?? []),
        ...(visualization?.regions ?? []).flatMap((region: any) => region?.pred ?? []),
    ];

    return predictions.flatMap((prediction: any) => {
        const mask = prediction.normalized_mask?.length ? prediction.normalized_mask : prediction.mask;
        return (mask ?? []).map((point: number[]) => ({
            x: point[0],
            y: point[1],
        }));
    });
}

export const getAnalysis = async (image: any, dispatch: any) => {
    let blobFace = await fetch(image).then((r) => r.blob());
    let count: number = 0

    dispatch({ type: ActionTypes.ANALYSE_UPDATE, value: AnalysisStep.start });
    dispatch({ type: ActionTypes.NO_WARNING });
    dispatch({ type: ActionTypes.ANALYSE_UPDATE, value: AnalysisStep.analysingFace });
    return getDemkyAnalysis(blobFace, dispatch, count)
}

const getDemkyAnalysis = async (blob: Blob, dispatch: any, count: number) => {
    const formdata = new FormData();
    const myHeaders = new Headers();
    myHeaders.append("X-API-Key", process.env.REACT_APP_DEMKY_API_KEY || "");

    formdata.append("image", blob, "image.jpg");
    formdata.append("concerns", "[\"DARK_CIRCLES\", \"ACNE\", \"WRINKLES\", \"EYE_BAGS\", \"REDNESS\", \"PORES_T_ZONE\", \"PORES_LEFT_CHEEK\", \"PORES_RIGHT_CHEEK\", \"WRINKLES\", \"LOWER_FACE_PTOSIS\", \"ROUGHNESS_LEFT_CHEEK\", \"ROUGHNESS_RIGHT_CHEEK\", \"ROUGHNESS_NOSE\", \"ROUGHNESS_CHIN\", \"ROUGHNESS_FOREHEAD\", \"DARK_SPOTS_RIGHT_CHEEK\", \"DARK_SPOTS_LEFT_CHEEK\", \"DARK_SPOTS_FOREHEAD\", \"DARK_SPOTS_LOWER_FACE\", \"DARK_SPOTS_NOSE\", \"HETEROGENEITY\", \"HOLLOW_CHEEKS_LEFT\", \"HOLLOW_CHEEKS_RIGHT\", \"TEAR_THROUGH\", \"INVISIBLE_DAMAGES\", \"DEHYDRATION\", \"WRINKLES_VISUALIZATION\"]");

    await fetch("https://demky.imaaagery.app/demky", {
        method: 'POST',
        body: formdata,
        redirect: 'follow',
        headers: myHeaders
    })
        .then(response => {
            if (!response.ok) throw new Error(`Demky API failed with status ${response.status}`);
            return response.json();
        })
        .then(result => {
            const hasValidResult = Object.values(result?.results ?? {}).some((concern: any) => {
                const level = concern?.level ?? concern?.correlated_level;
                return (typeof level === 'number' && Number.isFinite(level) && level >= 0)
                    || (typeof level === 'string' && (['high', 'medium', 'low', 'very_low'].includes(level)
                        || (level.trim() !== '' && Number.isFinite(Number(level)) && Number(level) >= 0)));
            });
            if (!hasValidResult) throw new Error('Demky API returned no valid analysis');
            const analyses = demkyParser(result);
            const invisibleDamages = result?.results?.INVISIBLE_DAMAGES
            const wrinklesVisualization = result?.results?.WRINKLES_VISUALIZATION
            const wrinklesPixels = getVisualizationPixels(wrinklesVisualization)
            dispatch({
                type: ActionTypes.UPDATE_DEMKY_INVISIBLE_DAMAGE,
                value: invisibleDamages?.detected_pixels
                    ? {
                        faceBoundingBox: result.face_bounding_box,
                        detectedPixels: invisibleDamages.detected_pixels,
                    }
                    : null,
            })
            dispatch({
                type: ActionTypes.UPDATE_DEMKY_WRINKLES_VISUALIZATION,
                value: wrinklesPixels.length
                    ? {
                        faceBoundingBox: result.face_bounding_box,
                        detectedPixels: wrinklesPixels,
                    }
                    : null,
            })
            dispatch({ type: ActionTypes.SET_ANALYSIS, value: analyses })
            dispatch({ type: ActionTypes.ANALYSE_UPDATE, value: AnalysisStep.done });
            trackPlausibleEvent('sd_photo_succeeded');
        })
        .catch((error) => {
            console.error(error)
            count++
            if (count < 3) {
                setTimeout(() => {
                    getDemkyAnalysis(blob, dispatch, count)
                }, 1000);
            } else {
                dispatch({ type: ActionTypes.ANALYSE_ERROR, value: [AnalysisError.no_analyse] });
                alert("Please try later.")
            }
        });

}
